import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "./InstallmentCalculation.scss";

const InstallmentCalculation = (props) => {
  const [spinner, setSpinner] = React.useState(false);
  const [selectData, setSelectData] = React.useState([]);
  const [productName, setProductName] = React.useState("");
  const [store, setStore] = React.useState("");
  const [productCode, setProductCode] = React.useState("");
  const [productPrice, setProductPrice] = React.useState("");
  const [creditBalance, setCreditBalance] = React.useState("");
  const [cashPay, setCashPay] = React.useState("");
  const [optionSelect, setOptionSelect] = React.useState({});
  // const [tblData, setTblData] = React.useState([]);
  const user = useSelector((state) => state.user);
  React.useEffect(async () => {
    await getSelectData();
  }, []);

  const getSelectData = () => {
    let config = {
      method: "get",
      url: "/Home/CalculateProviders",
      headers: {
        Authorization: user[0]?.token ? `Bearer ${user[0]?.token}` : "",
      },
    };

    axios(config)
      .then((response) => {
        if (response.status === 200) {
          setSelectData(response.data.data);
          setOptionSelect(response.data.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="InstallmentCalculationWrapper">
      <div className="desktop">
        <div className="InstallmentCalculationBox">
          <p className="InstallmentCalculationTitle">
            هم اکنون <span>سفارش دهید!</span>
          </p>

          {props.tblData.length > 0 && (
            <div className="InstallmentCalculationTable">
              <div className="th">
                <p className="td">قیمت کالا</p>
                <p className="td">پیش پرداخت نقد</p>
                <p className="td">مبلغ تقسیط</p>
                <p className="td">مدت اقساط</p>
                <p className="td">مبلغ هر قسط</p>
                <p className="td">مجموع اقساط</p>
                <p className="td">توضیحات</p>
                <p className="td">عملیات</p>
              </div>
              {props.tblData.length > 0 &&
                props.tblData.map((item, index) => {
                  return (
                    <div className="tr" key={index}>
                      <p className="td">{item.productPrice}</p>
                      <p className="td">{item.cashAdvancePayment}</p>
                      <p className="td">{item.installmentAmount}</p>
                      <p className="td">{item.installmentPeriod}</p>
                      <p className="td">{item.amountPerInstallment}</p>
                      <p className="td">{item.totalInstallments}</p>
                      <p className={item.canUse ? "td green" : "td red"}>{item.description}</p>
                      <p className="td pay" onClick={() => props.installMentPay(item)}>
                        پرداخت
                      </p>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(InstallmentCalculation);
